import type { Context } from "react";
import { useContext } from "react";

export function useStrictContext<T>(
  context: Context<T>,
  strictNullCheck = false,
): NonNullable<T> {
  const contextState = useContext(context);

  if (strictNullCheck ? contextState === null : contextState == null) {
    throw new Error(
      `useStrictContext must be used within ${
        context.displayName ?? ""
      }Provider`,
    );
  }

  return contextState as NonNullable<T>;
}
